import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function OpeningHook() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-white py-16 md:py-24 px-6" data-id="element-120">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.7
    }} className="max-w-4xl mx-auto" data-id="element-121">
        <div className="border-l-4 border-soft-gold pl-8 md:pl-12 space-y-6" data-id="element-122">
          <p className="text-xl md:text-2xl text-warm-brown leading-relaxed font-light italic" data-id="element-123">
            Son las 3:14 AM. Estás meciendo la cuna con un brazo que ya no
            sientes, mientras las lágrimas de cansancio se mezclan con la culpa
            de no saber qué más hacer. Miras a tu bebé y, aunque lo amas más que
            a nada, solo deseas un par de horas de silencio y descanso real.
          </p>
          <p className="text-lg md:text-xl text-warm-brown/90 leading-relaxed" data-id="element-124">
            Sé exactamente cómo se siente ese vacío en el pecho. Sé lo que es
            buscar soluciones en Google en plena madrugada mientras tu bebé
            llora y tú sientes que has fallado como madre. Pero el problema no
            eres tú, ni tu bebé. El problema es que te han enseñado métodos que
            luchan contra la biología, en lugar de trabajar con ella.
          </p>
        </div>
      </motion.div>
    </section>;
}